(function () {
  if (window.__storecrmFavoriteListEnhanced) return;
  window.__storecrmFavoriteListEnhanced = true;

  var STYLE_ID = 'storecrm-favorite-list-enhance-style';
  var productCache = new Map();
  var visibilityCache = new Map();

  function getLocaleCode() {
    var locale =
      (window.Shopify &&
        (window.Shopify.locale ||
          (window.Shopify.localization &&
            window.Shopify.localization.language &&
            window.Shopify.localization.language.isoCode))) ||
      document.documentElement.lang ||
      'ja';
    return String(locale || 'ja').toLowerCase();
  }

  function getTexts() {
    var isJa = getLocaleCode().indexOf('ja') === 0;
    if (isJa) {
      return {
        unit: '件',
        view: '商品ページへ',
        remove: 'お気に入り解除',
        tax: '税込',
      };
    }
    return {
      unit: 'items',
      view: 'View item',
      remove: 'Remove',
      tax: 'incl. tax',
    };
  }

  function getShopName() {
    if (window.Shopify && window.Shopify.shop) {
      return String(window.Shopify.shop).replace('.myshopify.com', '');
    }
    return '';
  }

  function normalizeProductUrl(href) {
    try {
      var url = new URL(href, window.location.origin);
      url.pathname = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/products\/)/i, '');
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return href || '#';
    }
  }

  function parseHandleAndVariant(href) {
    try {
      var normalized = normalizeProductUrl(href);
      var url = new URL(normalized, window.location.origin);
      var m = url.pathname.match(/^\/products\/([^/?#]+)\/?$/i);
      if (!m) return null;
      return {
        path: url.pathname,
        handle: decodeURIComponent(m[1] || ''),
        variantId: url.searchParams.get('variant') || '',
      };
    } catch (e) {
      return null;
    }
  }

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache.has(handle)) return productCache.get(handle);

    var encoded = encodeURIComponent(handle);
    var p = fetch('/products/' + encoded + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      });

    productCache.set(handle, p);
    return p;
  }

  function isPublishedInJson(product) {
    if (!product || typeof product !== 'object') return false;

    if (Object.prototype.hasOwnProperty.call(product, 'status')) {
      var status = String(product.status || '').toLowerCase();
      if (status && status !== 'active') return false;
    }

    if (Object.prototype.hasOwnProperty.call(product, 'published_scope')) {
      var scope = String(product.published_scope || '').toLowerCase();
      if (scope && scope !== 'web' && scope !== 'global') return false;
    }

    if (!product.published_at) return false;

    var publishedAt = Date.parse(product.published_at);
    if (!Number.isNaN(publishedAt) && publishedAt > Date.now()) return false;

    return true;
  }

  function hasNoIndexMeta(html) {
    if (!html) return false;
    return /<meta[^>]+name=["']robots["'][^>]*content=["'][^"']*noindex/i.test(html);
  }

  function isNoIndexHeader(res) {
    var robots = (res.headers.get('x-robots-tag') || '').toLowerCase();
    return robots.indexOf('noindex') >= 0;
  }

  function isPublicByPage(pathname) {
    if (!pathname) return Promise.resolve(false);

    if (visibilityCache.has(pathname)) return visibilityCache.get(pathname);

    var p = fetch(pathname, { credentials: 'same-origin', redirect: 'follow' })
      .then(function (res) {
        if (!res.ok) return false;
        if (isNoIndexHeader(res)) return false;
        return res.text().then(function (html) {
          if (hasNoIndexMeta(html)) return false;
          return true;
        });
      })
      .catch(function () {
        return false;
      });

    visibilityCache.set(pathname, p);
    return p;
  }

  async function shouldDisplayProduct(href, product) {
    if (!isPublishedInJson(product)) return false;

    var parsed = parseHandleAndVariant(href);
    if (!parsed || !parsed.path) return false;

    var pagePublic = await isPublicByPage(parsed.path);
    return pagePublic;
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    try {
      return new Intl.NumberFormat(getLocaleCode(), {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'JPY',
      }).format(cents / 100);
    } catch (e) {
      return String(cents);
    }
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.storecrm_favoritelist table{box-shadow:none}',
      '.storecrm_favoritelist.storecrm-fav-enhanced{max-width:980px;margin:24px auto 56px;padding:0 16px;color:#111}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-header{display:flex;justify-content:space-between;align-items:flex-end;gap:16px;border-bottom:1px solid #e6e6e6;padding-bottom:12px;margin-bottom:16px}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-title{margin:0;font-size:22px!important;font-weight:700;letter-spacing:.02em}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-count{margin-left:10px;font-size:13px;font-weight:600;color:#666}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-empty{display:block;padding:24px 0;color:#666;font-size:14px!important}',
      '.storecrm_favoritelist.storecrm-fav-enhanced table{width:100%;border-collapse:collapse}',
      '.storecrm_favoritelist.storecrm-fav-enhanced tbody.fav-list{display:flex;flex-direction:column;gap:12px}',
      '.storecrm_favoritelist.storecrm-fav-enhanced tbody.fav-list>tr{display:table;width:100%}',
      '.storecrm_favoritelist.storecrm-fav-enhanced td.fav-cell{border:0!important;padding:0!important}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-item{display:grid;grid-template-columns:120px 1fr 220px;gap:14px;padding:14px;border:1px solid #e6e6e6;background:#fff}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-thumb a{display:block}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-thumb img{width:120px;height:120px;object-fit:cover;background:#f7f7f7}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-info{min-width:0}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-brand{font-size:12px;color:#666;margin:0 0 6px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-name{margin:0 0 8px;font-size:14px;line-height:1.5;font-weight:600;word-break:break-word}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-name a{color:#111;text-decoration:none}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-name a:hover{text-decoration:underline}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-price{margin-top:10px;display:flex;align-items:baseline;gap:10px}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .price-now{font-size:18px;font-weight:800}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .price-tax{font-size:11px;color:#666}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .price-was{font-size:12px;color:#888;text-decoration:line-through}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-actions{display:flex;flex-direction:column;gap:10px;justify-content:center}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-actions-top{display:flex;flex-direction:column;gap:8px}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-btn{display:inline-flex;justify-content:center;align-items:center;min-height:40px;padding:8px 12px;border:1px solid #111;background:#111;color:#fff!important;text-decoration:none;font-size:13px;font-weight:700}',
      '.storecrm_favoritelist.storecrm-fav-enhanced .fav-remove{display:inline-flex;justify-content:center;align-items:center;min-height:36px;font-size:12px;color:#444!important;background:#fff;border:1px solid #ddd;text-decoration:none}',
      '@media (max-width:768px){.storecrm_favoritelist.storecrm-fav-enhanced .fav-item{grid-template-columns:96px 1fr;grid-template-areas:"thumb info" "actions actions"}.storecrm_favoritelist.storecrm-fav-enhanced .fav-thumb{grid-area:thumb}.storecrm_favoritelist.storecrm-fav-enhanced .fav-info{grid-area:info}.storecrm_favoritelist.storecrm-fav-enhanced .fav-actions{grid-area:actions}.storecrm_favoritelist.storecrm-fav-enhanced .fav-thumb img{width:96px;height:96px}}'
    ].join('');

    document.head.appendChild(style);
  }

  function updateHeader(container, count, texts) {
    var title = container.querySelector('h1');
    if (!title) return;

    title.classList.add('fav-title');

    var header = container.querySelector('.fav-header');
    if (!header) {
      header = document.createElement('div');
      header.className = 'fav-header';
      var box = document.createElement('div');
      box.appendChild(title);
      header.appendChild(box);
      container.insertBefore(header, container.firstChild);
    }

    var countEl = title.querySelector('.fav-count');
    if (!countEl) {
      countEl = document.createElement('span');
      countEl.className = 'fav-count';
      title.appendChild(countEl);
    }
    countEl.textContent = count + ' ' + texts.unit;
  }

  function refreshListState(container, texts) {
    if (!(container instanceof HTMLElement)) return;

    var tbody = container.querySelector('tbody');
    var rows = tbody ? Array.prototype.slice.call(tbody.querySelectorAll(':scope > tr')) : [];

    updateHeader(container, rows.length, texts);

    var table = container.querySelector('table');
    var nonItem = container.querySelector('.storecrm_favoritelist_non_item');

    if (rows.length === 0) {
      if (table) table.style.display = 'none';
      if (nonItem) nonItem.style.display = 'block';
    } else {
      if (table) table.style.display = 'table';
      if (nonItem) nonItem.style.display = 'none';
    }
  }

  function buildLink(text, href, className) {
    var a = document.createElement('a');
    a.className = className;
    a.href = href;
    a.textContent = text;
    return a;
  }

  async function fillBrandAndPrice(opts) {
    var href = opts.href;
    var variantId = opts.variantId;
    var brandEl = opts.brandEl;
    var priceEl = opts.priceEl;
    var rowEl = opts.rowEl;
    var containerEl = opts.containerEl;
    var texts = opts.texts;

    var parsed = parseHandleAndVariant(href);
    if (!parsed || !parsed.handle) return;

    var product = await fetchProductByHandle(parsed.handle);

    if (!(await shouldDisplayProduct(href, product))) {
      if (rowEl && rowEl.parentNode) {
        rowEl.parentNode.removeChild(rowEl);
        refreshListState(containerEl, texts);
      }
      return;
    }

    if (brandEl) {
      var vendor = product.vendor || getShopName();
      if (vendor) {
        brandEl.textContent = vendor;
        brandEl.style.display = 'block';
      }
    }

    var targetVariantId = String(variantId || parsed.variantId || '');
    var selected = null;

    if (Array.isArray(product.variants) && product.variants.length > 0) {
      if (targetVariantId) {
        selected = product.variants.find(function (v) {
          return String(v.id) === targetVariantId;
        });
      }
      if (!selected) {
        selected = product.variants.find(function (v) {
          return !!v.available;
        }) || product.variants[0];
      }
    }

    if (!selected || typeof selected.price !== 'number' || !priceEl) return;

    var html = '<span class="price-now">' + formatMoney(selected.price) + '</span>';
    html += '<span class="price-tax">' + texts.tax + '</span>';
    if (typeof selected.compare_at_price === 'number' && selected.compare_at_price > selected.price) {
      html += '<span class="price-was">' + formatMoney(selected.compare_at_price) + '</span>';
    }

    priceEl.innerHTML = html;
    priceEl.style.display = 'flex';
  }

  function enhanceRow(row, texts) {
    if (!(row instanceof HTMLTableRowElement)) return;
    if (row.dataset.storecrmFavEnhanced === '1') return;

    var tdLeft = row.querySelector('.storecrm_favoritelist_lefttd');
    var tdRight = row.querySelector('.storecrm_favoritelist_righttd');
    if (!tdLeft || !tdRight) return;

    var img = tdLeft.querySelector('img');
    var leftLinks = Array.prototype.slice.call(tdLeft.querySelectorAll('a'));
    var titleLink =
      leftLinks.find(function (a) {
        return !img || !a.contains(img);
      }) ||
      leftLinks[0] ||
      null;

    var rawHref = (titleLink && titleLink.getAttribute('href')) || '#';
    var href = normalizeProductUrl(rawHref);
    var title = (titleLink && titleLink.textContent && titleLink.textContent.trim()) || '';

    var linkWrap = tdRight.querySelector('.storecrm_favoritelist_links') || tdRight;
    var actions = Array.prototype.slice.call(linkWrap.querySelectorAll('a'));
    var removeLink =
      actions.find(function (a) {
        return !!(a.dataset && (a.dataset.productId || a.dataset.variantId));
      }) ||
      actions[actions.length - 1] ||
      null;

    var variantId = (removeLink && removeLink.dataset && removeLink.dataset.variantId) || '';

    var td = document.createElement('td');
    td.colSpan = 2;
    td.className = 'fav-cell';

    var item = document.createElement('div');
    item.className = 'fav-item';

    var thumb = document.createElement('div');
    thumb.className = 'fav-thumb';
    if (img) {
      var thumbLink = document.createElement('a');
      thumbLink.href = href;
      var thumbImg = img.cloneNode(true);
      thumbImg.loading = 'lazy';
      thumbLink.appendChild(thumbImg);
      thumb.appendChild(thumbLink);
    }

    var info = document.createElement('div');
    info.className = 'fav-info';

    var brand = document.createElement('p');
    brand.className = 'fav-brand';
    brand.textContent = getShopName();
    brand.style.display = brand.textContent ? 'block' : 'none';

    var name = document.createElement('p');
    name.className = 'fav-name';
    var nameLink = document.createElement('a');
    nameLink.href = href;
    nameLink.textContent = title;
    name.appendChild(nameLink);

    var price = document.createElement('div');
    price.className = 'fav-price';
    price.style.display = 'none';

    info.appendChild(brand);
    info.appendChild(name);
    info.appendChild(price);

    var actionCol = document.createElement('div');
    actionCol.className = 'fav-actions';

    var top = document.createElement('div');
    top.className = 'fav-actions-top';

    var viewBtn = buildLink(texts.view, href, 'fav-btn is-sub');
    top.appendChild(viewBtn);
    actionCol.appendChild(top);

    if (removeLink) {
      removeLink.className = 'storecrm_favoritelist_link fav-remove';
      removeLink.textContent = texts.remove;
      actionCol.appendChild(removeLink);
    }

    item.appendChild(thumb);
    item.appendChild(info);
    item.appendChild(actionCol);
    td.appendChild(item);

    row.innerHTML = '';
    row.appendChild(td);
    row.dataset.storecrmFavEnhanced = '1';

    fillBrandAndPrice({
      href: href,
      variantId: variantId,
      brandEl: brand,
      priceEl: price,
      rowEl: row,
      containerEl: row.closest('.storecrm_favoritelist'),
      texts: texts,
    });
  }

  function enhanceContainer(container) {
    if (!(container instanceof HTMLElement)) return;

    injectStyle();
    container.classList.add('storecrm-fav-enhanced');

    var texts = getTexts();
    var table = container.querySelector('table');
    var tbody = table && table.querySelector('tbody');
    var rows = tbody ? Array.prototype.slice.call(tbody.querySelectorAll(':scope > tr')) : [];

    rows.forEach(function (row) {
      enhanceRow(row, texts);
    });

    if (tbody) tbody.classList.add('fav-list');

    var nonItem = container.querySelector('.storecrm_favoritelist_non_item');
    if (nonItem) nonItem.classList.add('fav-empty');

    refreshListState(container, texts);
  }

  function enhanceAll() {
    var lists = document.querySelectorAll('.storecrm_favoritelist');
    if (!lists.length) return;
    lists.forEach(function (list) {
      enhanceContainer(list);
    });
  }

  var rafId = null;
  function scheduleEnhance() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      enhanceAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEnhance);
  } else {
    scheduleEnhance();
  }

  window.addEventListener('load', scheduleEnhance);

  var observer = new MutationObserver(function () {
    scheduleEnhance();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();